// extracted by mini-css-extract-plugin
export default {"heroSection":"HeroSection_heroSection__wREGf","btns":"HeroSection_btns__0ENS9","btn":"HeroSection_btn__1U17a"};